'use strict';

import _ from 'underscore';

export default function FeatureFlagsController(CurrentUserService) {
  var vm = this;
  vm.enabledForCurrentUser = enabledForCurrentUser;

  // not really bindable, but it makes testing better
  vm.init = init;

  init();

  function enabledForCurrentUser(featureName) {
    if (!vm.user) {
      return false;
    }

    return _.contains(vm.user.enabledFeatures, featureName);
  }

  function init() {
    return CurrentUserService.get().then(function(user) {
      vm.user = user;
    });
  }
}

FeatureFlagsController.$inject = ['CurrentUserService'];
